<template v-if="prep_task.id">
  <info-header-card :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import PrepTaskModel from "@/models/lab/PrepTaskModel";

export default {
  name: "PrepTaskCard",
  components: {
    InfoHeaderCard
  },
  props: {
    prep_task: {
      type: Object,
      default: () => new PrepTaskModel()
    }
  },
  computed: {
    header() {
      return this.prep_task.name;
    },
    rows() {
      return [
        {
          label: "Description",
          value: this.prep_task.description
        }
      ];
    }
  }
};
</script>
